import { gatsbyMediaArray } from './gatsbyMedia'
import { gatsbyBio } from './gatsbyBios'

import { hollyReviewerReviewHinge, luigiReviewerReviewBumble, frodoReviewerReviewTinder } from './gatsbyReviewerReviews'
import { hollyReviewerProfile, luigiReviewerProfile, frodoReviewerProfile } from './gatsbyReviewers'

export const hollyProfileReviewHinge = {
  _id: 'hollyProfileReviewHingeId',
  userId: 'gatsbyUserId',
  userEmail: 'gatsby@email.com',
  datingProfileId: 'gatsbyDatingProfileHingeId',
  reviewerProfileId: 'hollyReviewerProfileId',
  reviewerEmail: 'holly@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: gatsbyMediaArray[0]._id,
      mediaItemURL: gatsbyMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[0].type,
      caption: gatsbyMediaArray[0].captions[0],
      subcaption: gatsbyMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[1]._id,
      mediaItemURL: gatsbyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[1].type,
      caption: gatsbyMediaArray[1].captions[0],
      subcaption: gatsbyMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[5]._id,
      mediaItemURL: gatsbyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[5].type,
      caption: gatsbyMediaArray[5].captions[2],
      subcaption: gatsbyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[11]._id,
      mediaItemURL: gatsbyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[11].type,
      caption: gatsbyMediaArray[11].captions[0],
      subcaption: gatsbyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[8]._id,
      mediaItemURL: gatsbyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[8].type,
      caption: gatsbyMediaArray[8].captions[0],
      subcaption: gatsbyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[10]._id,
      mediaItemURL: gatsbyMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[10].type,
      caption: gatsbyMediaArray[10].captions[2],
      subcaption: gatsbyMediaArray[10].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stylish and suave! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Nice showing off the car but a bit of an awkward angle. Maybe Photoshop out the windshield`,
      verdict: 'Somewhat',
    },
    {
      feedback: `You look classy and distinguished here, but it might turn off some non-smokers`,
      verdict: 'Yes',
    },
    {
      feedback: `You're well dressed but the expression gives off negative energy. I'd change this for maybe something where you're not in a suit, like a beach pic or something`,
      verdict: 'No',
    },
    {
      feedback: `Again you look very dapper, but you're not giving off positive energy, and it's duplicative. OK, we get, you know how to dress up. What about the rest of your character?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Finally a smile! This is a great photo!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: gatsbyBio._id,
    vitalInfo: { ...gatsbyBio.vitalInfo },
    prompts: [
      { ...gatsbyBio.prompts[0] },
      { ...gatsbyBio.prompts[1] },
      { ...gatsbyBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `I think you spelled Oxford wrong... makes me wonder if you really went there`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get this`,
        verdict: 'No', 
      },
      {
        feedback: `Intriguing... accurate... and illegal... I'd be worried about someone showing this to the police`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is weird for both the people who do know Daisy and the people who don't know her`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Jay is very dapper and extravagantly wealthy, but maybe a bit intense.`,
    good: `You're obviously super financially well off, handsome, and well dressed`,
    notGood: `The intensity. Try a few more pictures where you're smiling and some wittier prompt responses. Also, try to add variety, there are too many photos of you in a suit and not enough of you doing candid things like hanging out at the beach or cooking a nice dinner`,
    verdict: `Overall you'll get good matches from your handsomeness and your extravagance, but to get the type of matches you actually want, you'll have to change your prompt responses and add more variety to your photos`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...hollyReviewerReviewHinge },
  reviewerProfile: { ...hollyReviewerProfile },
  bioItems: { ...gatsbyBio },
  mediaItems: [ ...gatsbyMediaArray ],
}

export const luigiProfileReviewBumble = {
  _id: 'luigiProfileReviewBumbleId',
  userId: 'gatsbyUserId',
  userEmail: 'gatsby@email.com',
  datingProfileId: 'gatsbyDatingProfileBumbleId',
  reviewerProfileId: 'luigiReviewerProfileId',
  reviewerEmail: 'luigi@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: gatsbyMediaArray[0]._id,
      mediaItemURL: gatsbyMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[0].type,
      caption: gatsbyMediaArray[0].captions[0],
      subcaption: gatsbyMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[1]._id,
      mediaItemURL: gatsbyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[1].type,
      caption: gatsbyMediaArray[1].captions[0],
      subcaption: gatsbyMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[5]._id,
      mediaItemURL: gatsbyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[5].type,
      caption: gatsbyMediaArray[5].captions[2],
      subcaption: gatsbyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[11]._id,
      mediaItemURL: gatsbyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[11].type,
      caption: gatsbyMediaArray[11].captions[0],
      subcaption: gatsbyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[8]._id,
      mediaItemURL: gatsbyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[8].type,
      caption: gatsbyMediaArray[8].captions[0],
      subcaption: gatsbyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[10]._id,
      mediaItemURL: gatsbyMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[10].type,
      caption: gatsbyMediaArray[10].captions[2],
      subcaption: gatsbyMediaArray[10].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stylish and suave! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Nice showing off the car but a bit of an awkward angle. Maybe Photoshop out the windshield`,
      verdict: 'Somewhat',
    },
    {
      feedback: `You look classy and distinguished here, but it might turn off some non-smokers`,
      verdict: 'Yes',
    },
    {
      feedback: `You're well dressed but the expression gives off negative energy. I'd change this for maybe something where you're not in a suit, like a beach pic or something`,
      verdict: 'No',
    },
    {
      feedback: `Again you look very dapper, but you're not giving off positive energy, and it's duplicative. OK, we get, you know how to dress up. What about the rest of your character?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Finally a smile! This is a great photo!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: gatsbyBio._id,
    vitalInfo: { ...gatsbyBio.vitalInfo },
    prompts: [
      { ...gatsbyBio.prompts[0] },
      { ...gatsbyBio.prompts[1] },
      { ...gatsbyBio.prompts[2] }
    ],
    aboutMe: gatsbyBio.aboutMe[0],
    hobbies: [gatsbyBio.hobbies[0], gatsbyBio.hobbies[1], gatsbyBio.hobbies[2], gatsbyBio.hobbies[3], gatsbyBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `I think you spelled Oxford wrong... makes me wonder if you really went there`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get this`,
        verdict: 'No', 
      },
      {
        feedback: `Intriguing... accurate... and illegal... I'd be worried about someone showing this to the police`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is weird for both the people who do know Daisy and the people who don't know her`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Jay is very dapper and extravagantly wealthy, but maybe a bit intense.`,
    good: `You're obviously super financially well off, handsome, and well dressed`,
    notGood: `The intensity. Try a few more pictures where you're smiling and some wittier prompt responses. Also, try to add variety, there are too many photos of you in a suit and not enough of you doing candid things like hanging out at the beach or cooking a nice dinner`,
    verdict: `Overall you'll get good matches from your handsomeness and your extravagance, but to get the type of matches you actually want, you'll have to change your prompt responses and add more variety to your photos`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...luigiReviewerReviewBumble },
  reviewerProfile: { ...luigiReviewerProfile },
  bioItems: { ...gatsbyBio },
  mediaItems: [ ...gatsbyMediaArray ],
}

export const frodoProfileReviewTinder = {
  _id: 'frodoProfileReviewTinderId',
  userId: 'gatsbyUserId',
  userEmail: 'gatsby@email.com',
  datingProfileId: 'gatsbyDatingProfileTinderId',
  reviewerProfileId: 'frodoReviewerProfileId',
  reviewerEmail: 'frodo@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: gatsbyMediaArray[0]._id,
      mediaItemURL: gatsbyMediaArray[0].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[0].type,
      caption: gatsbyMediaArray[0].captions[0],
      subcaption: gatsbyMediaArray[0].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[1]._id,
      mediaItemURL: gatsbyMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[1].type,
      caption: gatsbyMediaArray[1].captions[0],
      subcaption: gatsbyMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[5]._id,
      mediaItemURL: gatsbyMediaArray[5].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[5].type,
      caption: gatsbyMediaArray[5].captions[2],
      subcaption: gatsbyMediaArray[5].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[11]._id,
      mediaItemURL: gatsbyMediaArray[11].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[11].type,
      caption: gatsbyMediaArray[11].captions[0],
      subcaption: gatsbyMediaArray[11].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[8]._id,
      mediaItemURL: gatsbyMediaArray[8].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[8].type,
      caption: gatsbyMediaArray[8].captions[0],
      subcaption: gatsbyMediaArray[8].subcaptions[0],
    },
    {
      mediaItemId: gatsbyMediaArray[10]._id,
      mediaItemURL: gatsbyMediaArray[10].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: gatsbyMediaArray[10].type,
      caption: gatsbyMediaArray[10].captions[2],
      subcaption: gatsbyMediaArray[10].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look stylish and suave! Good start!`,
      verdict: 'Very',
    },
    {
      feedback: `Nice showing off the car but a bit of an awkward angle. Maybe Photoshop out the windshield`,
      verdict: 'Somewhat',
    },
    {
      feedback: `You look classy and distinguished here, but it might turn off some non-smokers`,
      verdict: 'Yes',
    },
    {
      feedback: `You're well dressed but the expression gives off negative energy. I'd change this for maybe something where you're not in a suit, like a beach pic or something`,
      verdict: 'No',
    },
    {
      feedback: `Again you look very dapper, but you're not giving off positive energy, and it's duplicative. OK, we get, you know how to dress up. What about the rest of your character?`,
      verdict: 'Somewhat',
    },
    {
      feedback: `Finally a smile! This is a great photo!`,
      verdict: 'Very',
    }
  ],
  bio: {
    bioItemsId: gatsbyBio._id,
    vitalInfo: { ...gatsbyBio.vitalInfo },
    prompts: [
      { ...gatsbyBio.prompts[0] },
      { ...gatsbyBio.prompts[1] },
      { ...gatsbyBio.prompts[2] }
    ],
    aboutMe: gatsbyBio.aboutMe[0],
    hobbies: [gatsbyBio.hobbies[0], gatsbyBio.hobbies[1], gatsbyBio.hobbies[2], gatsbyBio.hobbies[3], gatsbyBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `I think you spelled Oxford wrong... makes me wonder if you really went there`,
      verdict: 'Somewhat', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Nobody is going to get this`,
        verdict: 'No', 
      },
      {
        feedback: `Intriguing... accurate... and illegal... I'd be worried about someone showing this to the police`,
        verdict: 'Somewhat', 
      },
      {
        feedback: `This is weird for both the people who do know Daisy and the people who don't know her`,
        verdict: 'No', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Jay is very dapper and extravagantly wealthy, but maybe a bit intense.`,
    good: `You're obviously super financially well off, handsome, and well dressed`,
    notGood: `The intensity. Try a few more pictures where you're smiling and some wittier prompt responses. Also, try to add variety, there are too many photos of you in a suit and not enough of you doing candid things like hanging out at the beach or cooking a nice dinner`,
    verdict: `Overall you'll get good matches from your handsomeness and your extravagance, but to get the type of matches you actually want, you'll have to change your prompt responses and add more variety to your photos`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...frodoReviewerReviewTinder },
  reviewerProfile: { ...frodoReviewerProfile },
  bioItems: { ...gatsbyBio },
  mediaItems: [ ...gatsbyMediaArray ],
}